/**
 * en-GB messages added by Phase 4 task S46B (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s46bEnGB = {
    'dp.hit.block_entry': 'Block list entry',
    'dp.keep.safety': 'Block list entries are kept because they protect sites. Remove them from the block list if they should go.',
    'dp.section.notification_deliveries': 'Notifications sent',
    'dp.section.feedback_requests': 'Feedback requests',
    'dp.section.feedback_responses': 'Feedback answers',
    'dp.section.companion_devices': 'Companion app devices',
    'dp.section.companion_invites': 'Companion app invitations',
    'dp.section.block_entries': 'Block list entries',
    'dp.section.block_matches': 'Block list checks',
    'dp.section.event_attendees': 'Event attendance',
    'dp.section.webhook_deliveries': 'Messages sent to other systems',
    'dp.section.omp_inbound': 'Messages received from the linked system',
    'dp.section.external_links': 'Links to other systems',
    'dp.section.external_unmatched': 'People from other systems not yet matched',
    'dp.section.contactless_visitors': 'Remembered phone details',
    'dp.section.contactless_sessions': 'Phone sign-in sessions',
};
//# sourceMappingURL=s46b.js.map